import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_col = _resolveComponent("v-col");
    const _component_v_row = _resolveComponent("v-row");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_card_text = _resolveComponent("v-card-text");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        transition: "dialog-bottom-transition",
        "content-class": "responsive-dialog",
        "max-width": "65%"
    }, {
        activator: _withCtx(({ props }) => [
            _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps(props)))
        ]),
        default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "justify-center body-2" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.bill')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-1"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.order.storeName), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-1"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.order.storePhone), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.ceo_name', { ceoName: _ctx.order.storeDTO.ceoName })), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-1"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.order.storeDTO.addressBuildingName), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_divider, { class: "my-1" }),
                            _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-1"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.customer_phone', { customerPhone: _ctx.order.customerPhone })), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-1"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.order.dropAddressForPrivacy()), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-1"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.memo', { memo: _ctx.order.memo })), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_divider, { class: "my-1" }),
                            _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.date', { orderedDate: _ctx.orderedDate })), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_divider, { class: "my-1" }),
                            _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-1"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.goods_name')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.price')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_col, {
                                        cols: "auto",
                                        class: "ps-1"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.quantity')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_col, {
                                        cols: "auto",
                                        class: "ps-1"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.amount')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payments, (payment, key) => {
                                return (_openBlock(), _createBlock(_component_v_row, {
                                    key: `payment-${key}`,
                                    "no-gutters": "",
                                    class: "py-1"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                                _createElementVNode("div", null, " 임의 상품 ", -1 /* CACHED */)
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [0]
                                        }),
                                        _createVNode(_component_v_col, { cols: "auto" }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.currency(payment.payAmount)), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */),
                                        _createVNode(_component_v_col, {
                                            cols: "auto",
                                            class: "ps-1"
                                        }, {
                                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                _createElementVNode("div", null, " 1 ", -1 /* CACHED */)
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [1]
                                        }),
                                        _createVNode(_component_v_col, {
                                            cols: "auto",
                                            class: "ps-1"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.currency(payment.payAmount)), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */));
                            }), 128 /* KEYED_FRAGMENT */)),
                            _createVNode(_component_v_divider, { class: "my-1" }),
                            _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-1"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "text-end"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.taxable_value')), 1 /* TEXT */),
                                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.vat')), 1 /* TEXT */),
                                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info.total_amount')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_col, {
                                        cols: "6",
                                        class: "text-end"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.currency(_ctx.tax)), 1 /* TEXT */),
                                            _createElementVNode("div", null, _toDisplayString(_ctx.currency(_ctx.vat)), 1 /* TEXT */),
                                            _createElementVNode("div", null, _toDisplayString(_ctx.currency(_ctx.total)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 3 /* FORWARDED */
    }));
}
